import React from 'react';
import { Circle, G, Line, Path } from 'react-native-svg';
import { DT } from '../tokens';

type Props = { cx: number; cy: number; r?: number };

/** Fan symbol — circle with three curved blade lines. */
export function FanSymbol({ cx, cy, r = 22 }: Props) {
  // Three blade arcs (simplified as lines at 120° spacing)
  const blades = [0, 120, 240].map((deg) => {
    const rad = (deg * Math.PI) / 180;
    const bx = cx + (r * 0.65) * Math.cos(rad);
    const by = cy + (r * 0.65) * Math.sin(rad);
    const ex = cx + r * 0.9 * Math.cos(rad + 0.5);
    const ey = cy + r * 0.9 * Math.sin(rad + 0.5);
    return <Line key={deg} x1={bx} y1={by} x2={ex} y2={ey} stroke={DT.stroke} strokeWidth="2" strokeLinecap="round" />;
  });
  return (
    <G>
      <Circle cx={cx} cy={cy} r={r} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      <Circle cx={cx} cy={cy} r={4} fill={DT.stroke} />
      {blades}
    </G>
  );
}
